import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  putUserDetailsFailure,
  putUserDetailsSuccess,
} from "../slices/features/userDetails";
import { RequestTypes } from "../types";

const useDetailsService = new AppService();

function* updateUserDetailsSaga(action: any) {
  const { payload } = action;

  const { data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      useDetailsService.updateUserDetails,
      baseUrl,
      data
    );

    toast.success("Settings Updated");
    payload?.cbSuccess && payload?.cbSuccess();

    yield put(putUserDetailsSuccess({ ...response }));
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(putUserDetailsFailure({ statusCode, statusText }));
  }
}

export function* watchUserDetails() {
  yield takeLatest(
    RequestTypes.UPDATE_USER_DETAIL_REQUEST,
    updateUserDetailsSaga
  );
}
